export const moleculeNodes = [
  {
    id: "1",
    type: "startNode",
    position: { x: -200, y: 20 },
    data: {
      label: "Oxygen",
      formula: "O2",
      cost: 1,
      description: "x2.5 Mutliplier to all producers",
      unlocked: [],
      visible: [],
      max: 1e10,
    },
  },
  {
    id: "2",
    type: "startNode",

    position: { x: 200, y: 20 },
    data: {
      label: "Hydrogen",
      formula: "H2",
      cost: 1,
      description: "Start with more Particles",
      unlocked: [],
      visible: [],
      max: 10,
    },
  },
  {
    id: "3",
    type: "midNode",
    position: { x: 0, y: 220 },
    data: {
      label: "Water",
      formula: "H2O",
      cost: 2,
      description: "Improve the buy 10 multiplier formula.",
      unlocked: ["Oxygen", "Hydrogen"],
      visible: [],
      max: 1e10,
    },
  },
  {
    id: "4",
    type: "midNode",
    position: { x: -250, y: 420 },
    data: {
      label: "Ozone",
      formula: "O3",
      cost: 1,
      description: "x2 Multiplier to Molecule Creation",
      unlocked: ["Oxygen"],
      visible: ["Oxygen"],
      max: 1e10,
    },
  },
  {
    id: "5",
    type: "startNode",
    position: { x: -500, y: 120 },
    data: {
      label: "Carbon",
      formula: "C",
      cost: 1,
      description: "Unlock Producer Auto-Buyer",
      unlocked: [],
      visible: [],
      achievement: 14,
      max: 1,
    },
  },
  {
    id: "6",
    type: "midNode",
    position: { x: -500, y: 420 },
    data: {
      label: "Carbon Dioxide",
      formula: "CO2",
      cost: 2,
      description: "Improve the buy 100 multiplier formula",
      unlocked: ["Carbon", "Oxygen"],
      visible: ["Oxygen", "Carbon"],
      max: 1e10,
    },
  },
  {
    id: "7",
    type: "midNode",
    position: { x: 400, y: 220 },
    data: {
      label: "Methane",
      formula: "CH4",
      cost: 2,
      description: "Create Molecules for extra x1e10 Particles for +1 Molecule",
      unlocked: ["Hydrogen"],
      visible: ["Carbon", "Hydrogen"],
      max: 1e10,
    },
  },
  {
    id: "8",
    type: "midNodeTopOutput",
    position: { x: 380, y: 480 },
    data: {
      label: "Nitrogen",
      formula: "N2",
      cost: 2,
      description: "Producers are always unlocked",
      unlocked: ["Methane"],
      visible: ["Methane"],
      max: 1,
    },
  },
  {
    id: "9",
    type: "midNode",
    position: { x: 100, y: 530 },
    data: {
      label: "Ammonia",
      formula: "NH3",
      cost: 20,
      description: "Producers strengthening effects now all producers",
      unlocked: ["Nitrogen", "Water"],
      visible: ["Nitrogen", "Hydrogen"],
      max: 1,
    },
  },
  {
    id: "10",
    type: "midNode",
    position: { x: -580, y: 650 },
    data: {
      label: "Carbon Monoxide",
      formula: "CO",
      cost: 2,
      description: "Spped-Shop Upgrades Costs 1e5 less Particles",
      unlocked: ["Carbon Dioxide"],
      visible: ["Carbon Dioxide"],
      max: 10,
    },
  },
  {
    id: "11",
    type: "midNode",
    position: { x: -50, y: 750 },
    data: {
      label: "Chlorine",
      formula: "Cl",
      cost: 4,
      description: "Speed-Shop Auto-Buyer",
      unlocked: ["Ozone", "Ammonia"],
      visible: ["Oxygen", "Nitrogen", "Hydrogen"],
      max: 1,
    },
  },
  {
    id: "12",
    type: "midNodeTopOutput",
    position: { x: -150, y: 1010 },
    data: {
      label: "Hydrochloric Acid",
      formula: "HCl",
      cost: 8,
      description: "Strengthening Boost Multiplier x2",
      unlocked: ["Chlorine"],
      visible: ["Chlorine"],
      max: 1e10,
    },
  },
  {
    id: "13",
    type: "midNode",
    position: { x: -450, y: 920 },
    data: {
      label: "Sodium",
      formula: "Na",
      cost: 12,
      description: "Bulk buy Producer Strengthening +1",
      unlocked: ["Carbon Monoxide"],
      visible: ["Chlorine", "Carbon Dioxide"],
      max: 20,
    },
  },
  {
    id: "14",
    type: "midNode",
    position: { x: -550, y: 1150 },
    data: {
      label: "Sodium Chloride (Salt)",
      formula: "NaCl",
      cost: 14,
      description: "Not implemented yet (PS auto buy)",
      unlocked: ["Sodium"],
      visible: ["Carbon Monoxide", "Hydrochloric Acid"],
      max: 1,
    },
  },
  {
    id: "15",
    type: "midNode",
    position: { x: -750, y: 900 },
    data: {
      label: "Ethanol",
      formula: "C2H6O",
      cost: 20,
      description: "Some Molecules can be purchased multiple times",
      unlocked: ["Carbon Monoxide"],
      visible: ["Carbon Monoxide", "Ammonia"],
      max: 1,
    },
  },
  {
    id: "16",
    type: "midNodeTopOutput",
    position: { x: -500, y: 1400 },
    data: {
      label: "Nitroglycerin",
      formula: "C3H5N3O9",
      cost: 100,
      description: "Not implemented yet (Explosion)",
      unlocked: ["Sodium Chloride (Salt)"],
      visible: ["Carbon Monoxide", "Hydrochloric Acid"],
      max: 1,
    },
  },
  {
    id: "17",
    type: "endNode",
    position: { x: -800, y: 1350 },
    data: {
      label: "Glucose",
      formula: "C6H12O6",
      cost: 100000,
      description: "Not implemented yet (Molecule Producer)",
      unlocked: ["Ethanol", "Nitroglycerin"],
      visible: ["Carbon Monoxide", "Ammonia", "Hydrochloric Acid"],
      max: 1,
    },
  },
  {
    id: "18",
    type: "endNode",
    position: { x: -800, y: 380 },
    data: {
      label: "Propane",
      formula: "C3H6",
      cost: 6,
      description: "Unlock alternate Neutron-Form: Electron",
      unlocked: ["Carbon"],
      visible: ["Carbon"],
      max: 1,
    },
  },
  {
    id: "19",
    type: "endNode",
    position: { x: 150, y: 1050 },
    data: {
      label: "Butane",
      formula: "C4H10",
      cost: 100,
      description: "Unlock alternate Neutron-Form: Proton",
      unlocked: ["Chlorine"],
      visible: ["Oxygen", "Nitrogen", "Hydrogen"],
      max: 1,
    },
  },
];

//ps no longer resets producers
//sb no longer resets producers
//sb no longer resets ps
//auto ps
//auto sb
//auto buy interval

export const moleculeEdges = [
  {
    id: "oxy-water",
    source: "1",
    target: "3",
    style: { strokeWidth: 3 },
  },
  { id: "hydro-water", source: "2", target: "3", style: { strokeWidth: 3 } },
  { id: "oxy-ozone", source: "1", target: "4", style: { strokeWidth: 3 } },
  { id: "carb-carbdi", source: "5", target: "6", style: { strokeWidth: 3 } },
  { id: "oxy-carbdi", source: "1", target: "6", style: { strokeWidth: 3 } },
  { id: "hydro-methane", source: "2", target: "7", style: { strokeWidth: 3 } },
  { id: "methane-nitro", source: "7", target: "8", style: { strokeWidth: 3 } },
  { id: "nitro-ammonia", source: "8", target: "9", style: { strokeWidth: 3 } },
  { id: "water-ammonia", source: "3", target: "9", style: { strokeWidth: 3 } },
  {
    id: "carbdi-carbmono",
    source: "6",
    target: "10",
    style: { strokeWidth: 3 },
  },
  { id: "chlorine-hcl", source: "11", target: "12", style: { strokeWidth: 3 } },
  {
    id: "ammonia-chlorine",
    source: "9",
    target: "11",
    style: { strokeWidth: 3 },
  },
  {
    id: "ozone-chlorine",
    source: "4",
    target: "11",
    style: { strokeWidth: 3 },
  },
  {
    id: "hydroacid-sodium",
    source: "12",
    target: "13",
    style: { strokeWidth: 3 },
  },
  {
    id: "carbmono-sodium",
    source: "10",
    target: "13",
    style: { strokeWidth: 3 },
  },
  { id: "sodium-salt", source: "13", target: "14", style: { strokeWidth: 3 } },
  {
    id: "carbmono-ethanol",
    source: "10",
    target: "15",
    style: { strokeWidth: 3 },
  },
  { id: "salt-nitro", source: "14", target: "16", style: { strokeWidth: 3 } },
  {
    id: "ethanol-glucose",
    source: "15",
    target: "17",
    style: { strokeWidth: 3 },
  },
  {
    id: "nitro-glucose",
    source: "16",
    target: "17",
    style: { strokeWidth: 3 },
  },
  {
    id: "chlorine-butane",
    source: "11",
    target: "19",
    style: { strokeWidth: 3 },
  },
  {
    id: "carbon-butpropaneane",
    source: "5",
    target: "18",
    style: { strokeWidth: 3 },
  },
];
